import { CATEGORIES_TYPES } from "./categoriesTypes";
import { convertToObjById } from "helpers/convertToObject";

const {
    GET_CATEGORIES,
} = CATEGORIES_TYPES

const initialState = {
    categories: [],
}

export const categoriesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_CATEGORIES:
            return {
                ...state,
                categories: convertToObjById(payload)
            }
        default: return state
    }
}